/**
 * Filter `type` value used by the workplace rating-prompt Knock guide. Authors of
 * the guide in the Knock dashboard set this as the guide type so `useGuides`
 * matches it from `ReviewPromptGuide`. Other Knock surfaces (`banner`, `modal`)
 * are untouched.
 */
export const REVIEW_PROMPT_GUIDE_TYPE = "workplace-app-store-review-soft-prompt";

/**
 * Knock user attribute that holds the ISO timestamp of the last time the
 * rating prompt's native review sheet was *requested*. Read by the Knock
 * dashboard's `daysSinceLastReviewPromptedAt` targeting rule so the gap
 * between prompts is dashboard-tunable (D-04).
 *
 * Caveat: the Capacitor plugin resolves whether the OS actually displayed
 * the sheet or silently rate-limited it (Apple caps to 3 per app per 365d;
 * Play also throttles). We persist the timestamp on every request, so a
 * rate-limited prompt counts the same as a shown prompt for cooldown.
 */
export const KNOCK_LAST_REVIEW_PROMPTED_AT_ATTRIBUTE = "lastReviewPromptedAt";
